import { BadRequestException } from '../exceptions/BadRequestException'
import { ForbiddenException } from '../exceptions/ForbiddenException'
import { NotFoundException } from '../exceptions/NotFoundException'
import { SerializationHelper } from '../utils/SerializationHelper'
import { StringUtils } from '../utils/StringUtils'
import { AbstractModel } from './AbstractModel'
import { Team } from './Team'
import { Http } from '@/lib/utils/Http'
import { RallyRoundHeaderImage } from './RallyRoundHeaderImage'
import { Rally } from './Rally'
import { User } from './User'

export class RallyRound extends AbstractModel {
  public id: number|null = null;
  public rallyRoundId: number|null = null;
  public rallyId: number|null = null;
  public name: string|null = null;
  public description: string|null = null;
  public link: string|null = null;
  public logo: string|null = null;
  public team_types_1: string|null = null;
  public team_types_2: string|null = null;
  public team_types_3: string|null = null;
  public customerRegisterEditableTil: string|null = null;
  public teamname: string|null = null;
  public maxTeamSize1: number|null = null;
  public maxTeamSize2: number|null = null;
  public maxTeamSize3: number|null = null;
  public dateBegin = ''
  public dateEnd = ''
  public providedVehicleId: number|null = null;
  public shopDonateId: number|null = null;
  public termId: number | null = null;
  public headerImage: RallyRoundHeaderImage | null = null;
  public defaultTeamLogoId: number|null = null;
  public defaultTeamLogoPath: string|null = null;
  public backgroundImageId: number|null = null;
  public backgroundImagePath: string|null = null;
  public voucherId: number|null = null;
  public voucherImagePath: string|null = null;
  public driveUploaderLink = ''
  public rodeoName = ''

  isAlright (): boolean {
    if (!this.headerImage ||
      !this.defaultTeamLogoPath ||
      !this.backgroundImagePath ||
      !this.voucherImagePath) {
      return false
    }
    return true
  }

  getRallyName (rallies: Rally[]) {
    const rally = rallies.find(rally => this.rallyId === rally.id)
    if (!rally) {
      return ''
    }
    return rally.name
  }

  async getUsers (rallyRoundId = this.rallyRoundId): Promise<User[]> {
    const classPath = StringUtils.toKebabCase(this.constructor.name.split('_')[0])
    const res = await Http.request(`${AbstractModel.apiBase}/${classPath}/${rallyRoundId}/users`)

    const resData = await res.json()

    return SerializationHelper.toInstanceArray(User, resData)
  }

  async getTeams (): Promise<Team[]> {
    const classPath = StringUtils.toKebabCase(this.constructor.name.split('_')[0])
    const res = await Http.request(`${AbstractModel.apiBase}/${classPath}/${this.id}/teams`)
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
      case 400:
        throw new BadRequestException()
    }

    const resData = await res.json()

    return SerializationHelper.toInstanceArray(Team, resData)
  }

  static async downloadCustomersCSV (rallyRoundId = -1) {
    if (rallyRoundId <= 0) {
      await Http.request('/api/customer/download')
    } else {
      window.location.assign(`/api/rally-round/${rallyRoundId}/customer/download`)
    }
  }

  static async downloadCrewCSV (rallyId = -1, rallyRoundId = -1) {
    window.location.assign(`/api/customer/crew/download/${rallyId}/${rallyRoundId}`)
  }

  async getLoggedInTeam (): Promise<Team> {
    const res = await Http.request(`${AbstractModel.apiBase}/${StringUtils.toKebabCase(this.constructor.name.split('_')[0])}/${this.id}/team/logged-in`)
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
      case 400:
        throw new BadRequestException()
    }

    const resData = await res.json()

    return SerializationHelper.toInstance(new Team(), resData)
  }

  static getRallyRoundNameById (id: number, rallies: Rally[], rallyRounds: RallyRound[]) {
    const foundRound = rallyRounds.find((rallyRound: RallyRound) => rallyRound.id === id)
    if (!foundRound) {
      return ''
    }
    return `${foundRound.getRallyName(rallies)} ${foundRound.name}`
  }
}
